import { Box, Button, Input, Text, Textarea } from '@chakra-ui/react'
import React from 'react'
import { PhoneIcon, EmailIcon } from '@chakra-ui/icons'


export const Contact = ({id}) => {

    let LinkDin =<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"/></svg>


  return (
        <div style={{marginTop:"100px"}} id={id}>

<Text  fontSize={"35px"} fontWeight={"bold"} color={"#01D0E2"} textAlign={"center"} >Contact</Text>    

<Box mt="50px">

            <Box display="grid" placeItems={"center"} mt="20px">

    <Box w="85%" display={"flex"} justifyContent={"space-around"} flexWrap="wrap">
        
        <Box  textAlign={"center"} lineHeight={"35px"}>
        <Box h="30px" w="40px" m="auto">
        <a style={{width:"40px", height:"30px"}} href="https://www.linkedin.com/in/chakresh-476070119/">{LinkDin}</a>
        </Box>
        <Text mt="10px">LinkedLn</Text>
        {/* <Text>You can contact me on LinkedIn</Text> */}
        <Text><a href="https://www.linkedin.com/in/chakresh-476070119/">Chakresh .</a></Text>
        </Box>


        <Box  textAlign={"center"} lineHeight={"35px"}>
        <PhoneIcon h="30px" w={"40px"}/>
        <Text>Phone</Text>
        {/* <Text>Here is My Phone Number</Text> */}
        <Text id="contact-phone">+91 8240754900</Text>
        </Box>


        <Box textAlign={"center"} letterSpacing={1} lineHeight={"35px"}>
            <EmailIcon h="40px" w={"60px"}/>
            <Text>Email</Text>
            {/* <Text>You can mail me on this mail ID</Text> */}
            <Text id="contact-email">jha.chakresh2001@gmail.com</Text>
        </Box>

        

    </Box>



    </Box>


    <Box display="grid" placeItems={"center"} mt="50px" >
        <Box w="85%"  justifyContent={"space-evenly"} display="flex" flexWrap="wrap">

        <Box >
            <Input mt="30px" border="1px solid black" placeholder={"Name"} borderRadius={"none"}/>
            <Input mt="30px"  border="1px solid black" placeholder={"Email"} borderRadius={"none"}/>
            <Input mt="30px"  border="1px solid black" placeholder={"Subject"} borderRadius={"none"}/>
        </Box>
        
        <Box>
            <Textarea mt="30px" placeholder={"Your message"}  border="1px solid black" borderRadius={"none"} w="500px" h="179px"/>
        </Box>


    </Box>
        </Box>

        <Box mb="50px" mt="20px" w="90%" display={"flex"} justifyContent={"flex-end"}>
        <Button borderRadius={"25px"} backgroundColor={"#E6E7E2"} >Send Message</Button>
        </Box>
    


</Box>


</div>
  
  )
}
